<div class="container" *ngIf="works">
  <section class="row">
    <div class="col-sm-12">
      <br>
      <h1 class="page-header details">{{ works.fields.title }}</h1>
    </div>
  </section>

  <section class="row carousel-content">
    <div class="col-sm-12">
      <mdb-carousel class="carousel slide carousel-fade" [type]="'carousel-thumbnails'" [animation]="'fade'">
        <mdb-carousel-item *ngFor="let gallery of works.fields.slideshowGallery">
            <div><img class="d-block" src="{{ gallery.fields.file.url }}" alt="First slide"></div>
        </mdb-carousel-item>
      </mdb-carousel>
    </div>
  </section>
  
  <section class="row padding-bottom">
    <div class="col-md-8 col-sm-12 intro">
      <h2>{{ works.fields.title }}</h2>
      <div class="subtitle" [innerHTML]="works.fields.subTitle | mdToHtml" *ngIf="works.fields.subTitle"></div>
      <div [innerHTML]="works.fields.introContent | mdToHtml"></div>
    </div>
    <div class="col-md-4 col-sm-12">
      <div class="sharethis-inline-share-buttons"></div>
    </div>
    <div class="col-sm-12 description" *ngIf="works.fields.mainContent">
      <div [innerHTML]="works.fields.mainContent | mdToHtml"></div>
    </div>
    <div class="col-sm-12 video" *ngIf="works.fields.videoTitle">
      <h5>{{ works.fields.videoTitle }}</h5>
      <div *ngFor="let video of works.fields.videoLink" class="videoWrapper">
        <iframe [src]="video | safePipe " width="100%" height="380" frameborder="0" webkitallowfullscreen=""
          mozallowfullscreen="" allowfullscreen=""></iframe>
      </div>
    </div>
  </section>
</div>
